class BrandDay2025Subscribe extends HTMLElement {
  // 首次加载
  firstInit = true;
  // 已提交
  alreadySubmit = false;

  constructor() {
    super();
    this.klaviyoForm = this.querySelector('[data-my-klaviyo-form]');
    this.klaviyoFormWrapper = this.querySelector('[data-my-klaviyo-form-wrapper]');
    this.checkbox = this.querySelector('.klaviyo-form-policy__check input');
    this.checkboxAlert = this.querySelector('.klaviyo-form-policy__alert');
    this.listener();
  }

  listener() {
    document.addEventListener('click', (e) => {
      if (!e.target.closest('brand-day-2025-subscribe')) {
        this.checkboxAlert.classList.remove('active');
      }
    });
    this.checkbox.addEventListener('change', (e) => {
      if (e.target.checked) {
        this.checkboxAlert.classList.remove('active');
      }
    });
    this.interval = setInterval(() => {
      if (this.klaviyoForm.childNodes.length == 0) return;
      if (this.firstInit) {
        this.submitButton = this.querySelector('button');
        this.submitButtonWrapper = this.submitButton.parentElement;
        this.submitButtonWrapper.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.checkbox.checked) {
            this.checkboxAlert.classList.remove('active');
            this.submitButton.click();
          } else {
            this.checkboxAlert.classList.add('active');
          }
        });
        this.firstInit = false;
      }
      const emailInput = this.klaviyoForm?.querySelector('input[type="email"]');
      if (!emailInput) {
        this.klaviyoFormWrapper?.setAttribute('data-submit', 'true');
      } else if (this.klaviyoFormWrapper?.hasAttribute('data-submit')) {
        this.klaviyoFormWrapper?.removeAttribute('data-submit');
      }
      // 是否提交成功
      if (this.klaviyoForm.querySelector('h1') && !this.alreadySubmit) {
        // 提交成功触发埋点 
        window.dataLayer.push({ event_parameters: null });
        window.dataLayer.push({
          event: 'ga4Event',
          event_name: 'subscribe',
          event_parameters: {
            button_name: 'email icon',
          },
        });
        this.classList.add('form-submit--success');
        this.alreadySubmit = true;
      }
    }, 100);
  }

  connectedCallback() { }

  static define(tagName) {
    const _tagName = tagName ?? 'brand-day-2025-subscribe';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, BrandDay2025Subscribe)
    }
  }
}

BrandDay2025Subscribe.define();

class BrandDay2025UgcVideoSlide extends HTMLElement {
  constructor() {
    super();
    this._handleClick = this.handleClick.bind(this);
    this.isMobileMQL = window.matchMedia(`(max-width: 768px)`);
    this._onChangeMediaQuery = this.onChangeMediaQuery.bind(this);
  }

  connectedCallback() {
    this.videoPcSource = this.getAttribute('data-video-souce-pc');
    this.videoMobileSource = this.getAttribute('data-video-souce-mb');
    this.plyrElement = this.querySelector('[data-plyr-element]');
    this.dialogButton = this.querySelector('[data-button-dialog]');
    this.playButton = this.querySelector('[data-button-play]');
    this.replayButton = this.querySelector('[data-button-replay]');

    this.addEventListener('click', this._handleClick);
    this.isMobileMQL.addEventListener('change', this._onChangeMediaQuery);
    this.onChangeMediaQuery();
    this.init();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this._handleClick);
    this.isMobileMQL.removeEventListener('change', this._onChangeMediaQuery);
  }

  handleClick(e) {
    /** @type {HTMLElement} */
    const playButton = e.target.closest('[data-button-play]');
    const replayButton = e.target.closest('[data-button-replay]');
    const dialogButton = e.target.closest('[data-button-dialog]');
    if (dialogButton) {
      const dialogid = dialogButton.getAttribute('data-button-dialog');
      document.querySelector(`[data-dialog-id="${dialogid}"]`).open();
    }
    if (playButton) {
      this.toggle();
    }
    if (replayButton) {
      this.stop();
      this.play();
    }
  }

  onChangeMediaQuery(_) {
    const isMobile = this.isMobileMQL.matches;
    const videoElement = this.querySelector('video');
    if (!isMobile && this.videoPcSource && videoElement) {
      videoElement.src = this.videoPcSource;
      videoElement.querySelector('source').setAttribute('src', this.videoPcSource);
    }
    if (isMobile && this.videoMobileSource && videoElement) {
      videoElement.src = this.videoMobileSource;
      videoElement.querySelector('source').setAttribute('src', this.videoMobileSource);
    }
  }

  init(autoplay = true) {
    this.player = new Plyr(this.plyrElement, {
      autoplay: autoplay,
      loop: {
        active: true
      },
      controls: ['progress'],
      tooltips: {
        controls: true,
        seek: false,
      },
      muted: true,
      ratio: null,
      quality: { default: 720, options: [4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240] }
    });
  }

  toggle() {
    if (!this.player) {
      this.init();
      this.playButton.setAttribute('is-playing', true);
    } else if (this.player?.playing) {
      this.player.pause();
      this.playButton.setAttribute('is-playing', false);
    } else {
      this.player.play();
      this.playButton.setAttribute('is-playing', true);
    }
  }

  play() {
    if (!this.player) {
      this.init();
    } else {
      this.player.play();
    }
    this.playButton.setAttribute('is-playing', true);
  }

  pause() {
    if (this.player) {
      this.player.pause();
    }
    this.playButton.setAttribute('is-playing', false);
  }

  stop() {
    if (this.player) {
      this.player.stop();
    }
    this.playButton.setAttribute('is-playing', false);
  }

  static define(tagName) {
    const _tagName = tagName ?? 'brand-day-2025-ugc-video-slide';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, BrandDay2025UgcVideoSlide)
    }
  }
}
BrandDay2025UgcVideoSlide.define();


class BrandDay2025UgcVideoSection extends HTMLElement {
  prevIndex = 0;

  constructor() {
    super();
    this._handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.section = this.closest('brand-day-2025-ugc-video-section');
    this.swiperElement = this.querySelector('.swiper');
    this.initSwiper();
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeListener('click', this._handleClick);
  }

  handleClick(e) {
    /** @type {HTMLElement} */
    const tab = e.target.closest('[data-tab-item]');
    if (tab) {
      const index = Number(tab.getAttribute('data-tab-item'));
      // this.querySelector('[data-tab-item].active')?.classList.remove('active');
      // tab.classList.add('active');
      this.mySwiper.slideTo(index);
    }
  }

  onSlideChange(index) {
    this.querySelector('[data-tab-item].active')?.classList.remove('active');
    this.querySelector(`[data-tab-item="${index}"]`)?.classList.add('active');
  }

  initSwiper() {
    this.mySwiper = new Swiper(this.swiperElement, {
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      // allowTouchMove: false,
      navigation: {
        prevEl: this.querySelector('[data-swiper-button-prev]'),
        nextEl: this.querySelector('[data-swiper-button-next]'),
      },
      on: {
        slideChange: () => {
          if (this.mySwiper) {
            const activeIndex = this.mySwiper.activeIndex;
            const slide = this.mySwiper.slides[activeIndex];
            slide.play();
            if (this.prevIndex != undefined) {
              const prevSlide = this.mySwiper.slides[this.prevIndex];
              prevSlide?.stop();
            }
            this.prevIndex = activeIndex;
            this.section.onSlideChange(this.mySwiper.activeIndex);
          }
        },
      },
    });
  }

  static define(tagName) {
    const _tagName = tagName ?? 'brand-day-2025-ugc-video-section';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, BrandDay2025UgcVideoSection)
    }
  }
}
BrandDay2025UgcVideoSection.define();


class DialogExitPopVideo extends HTMLElement {
  exit = false;

  constructor() {
    super();
    this._handleClose = this.handleClose.bind(this);
  }

  connectedCallback() {
    this.videoId = this.getAttribute('data-video-id');

    this.playerElement = this.querySelector('[data-dialog-player]');
    this.contentElement = this.querySelector('.content');
    this.closeButton = this.querySelector('.close-exit-pop');
    this.closeButton.addEventListener('click', this._handleClose);
  }

  disconnectedCallback() {
    this.removeListener('click', this._handleClose);
  }

  handleClose(e) {
    this.close();
  }

  open() {
    this.exit = false;
    this.classList.add('active');
    this.contentElement.classList.add('active');
    this.play();
  }

  close() {
    this.exit = true;
    this.classList.remove('active');
    this.contentElement.classList.remove('active');
    this.stop();
  }

  initVideo() {
    console.log('initVideo', YT, this.videoId);
    this.player = new YT.Player(this.playerElement, {
      videoId: this.videoId,
      events: {
        onReady: (_) => {
          if (!this.exit) {
            this.player.playVideo();
          }
        },
      },
    });
  }

  play() {
    if (!this.player) {
      this.initVideo();
    } else {
      this.player.playVideo();
    }
  }

  stop() {
    this.player?.stopVideo();
  }

  static define(tagName) {
    const _tagName = tagName ?? 'dialog-exit-pop-video';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, DialogExitPopVideo)
    }
  }
}
DialogExitPopVideo.define();


class BrandDay2025InnovationVideoSection extends HTMLElement {
  prevIndex = 0;

  constructor() {
    super();
    this._handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.swiperElement = this.querySelector('.swiper');
    this.initSwiper();
    this.addEventListener('click', this._handleClick);
  }

  disconnectedCallback() {
    this.removeListener('click', this._handleClick);
  }

  handleClick(e) {
    /** @type {HTMLElement} */
    const avatar = e.target.closest('[data-avatar-index]');
    if (avatar) {
      const index = Number(avatar.getAttribute('data-avatar-index'));
      this.mySwiper.slideTo(index);
    }
  }

  onSlideChange(index) {
    this.querySelector(`[data-avatar-index="${this.prevIndex}"]`)?.classList.remove('active');
    this.querySelector(`[data-avatar-index="${index}"]`)?.classList.add('active');
  }

  initSwiper() {
    this.mySwiper = new Swiper(this.swiperElement, {
      slidesPerView: 'auto',
      observer: true,
      observeParents: true,
      autoHeight: true,
      loop: true,
      // allowTouchMove: false,
      navigation: {
        prevEl: this.querySelector('[data-swiper-button-prev]'),
        nextEl: this.querySelector('[data-swiper-button-next]'),
      },
      on: {
        slideChange: () => {
          if (this.mySwiper) {
            const activeIndex = this.mySwiper.realIndex;
            this.onSlideChange(this.mySwiper.realIndex);
            this.prevIndex = activeIndex;
          }
        },
      },
    });
  }

  static define(tagName) {
    const _tagName = tagName ?? 'brand-day-2025-innovation-video-section';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, BrandDay2025InnovationVideoSection)
    }
  }
}
BrandDay2025InnovationVideoSection.define();

class BrandDay2025InnovationVideo extends BrandDay2025UgcVideoSlide {
  constructor() {
    super();
  }

  static define(tagName) {
    const _tagName = tagName ?? 'brand-day-2025-innovation-video';
    if (!customElements.get(_tagName)) {
      customElements.define(_tagName, BrandDay2025InnovationVideo)
    }
  }
}
BrandDay2025InnovationVideo.define();

if (!customElements.get('brand-day-2025-wishlist-wall-line')) {
  class BrandDay2025WishlistWallLine extends HTMLElement {
    constructor() {
      super();
      this.initCSSAnimation();
    }

    initCSSAnimation() {
      const wrapper = this.querySelector('.swiper-wrapper');
      if (!wrapper) return;

      // 复制内容用于无缝循环
      this.duplicateContent(wrapper);

      // 设置动画
      this.startAnimation(wrapper);

      // 添加交互
      // this.addEventListeners(wrapper);
    }

    duplicateContent(wrapper) {
      const originalSlides = wrapper.querySelectorAll('.swiper-slide');
      const totalWidth = this.calculateTotalWidth(originalSlides);

      // 复制足够的内容确保无缝循环（复制2-3次）
      for (let i = 0; i < 2; i++) {
        originalSlides.forEach(slide => {
          const clone = slide.cloneNode(true);
          clone.classList.add('slide-clone');
          wrapper.appendChild(clone);
        });
      }
    }

    calculateTotalWidth(slides) {
      return Array.from(slides).reduce((total, slide) => {
        return total + slide.offsetWidth +
          parseInt(getComputedStyle(slide).marginLeft || 0) +
          parseInt(getComputedStyle(slide).marginRight || 0);
      }, 0);
    }

    startAnimation(wrapper) {
      const originalSlides = wrapper.querySelectorAll('.swiper-slide:not(.slide-clone)');
      const totalWidth = this.calculateTotalWidth(originalSlides);
      const duration = (totalWidth / 100) * 3000; // 根据内容长度调整速度

      wrapper.style.animation = `infiniteScroll ${duration}ms linear infinite`;
    }

    addEventListeners(wrapper) {
      this.addEventListener('mouseenter', () => {
        wrapper.style.animationPlayState = 'paused';
      });

      this.addEventListener('mouseleave', () => {
        wrapper.style.animationPlayState = 'running';
      });
    }
  }

  customElements.define('brand-day-2025-wishlist-wall-line', BrandDay2025WishlistWallLine);
}